import { Component, Input, OnInit } from '@angular/core';
import { getDifference } from 'src/shared/utils/date.utils';

@Component({
  selector: 'app-time-ago',
  templateUrl: './time-ago.component.html',
  styleUrls: ['./time-ago.component.scss'],
  standalone: false
})
export class TimeAgoComponent implements OnInit {
  @Input() dateTime: string;
  currentDate: Date;

  ngOnInit(): void {
    this.currentDate = new Date();
  }

  calculateTime(dateTime: string) {
    if (!dateTime) { return ''; }

    const [datePart, timePart] = dateTime.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hour, minute, second] = timePart.split(':').map(Number);
    const date = new Date(year, month - 1, day, hour, minute, second);

    const diffSecond = getDifference(this.currentDate, date, 'second');
    let activity: string;

    if (diffSecond < 60) {
      activity = `${diffSecond}s`;
    } else if (diffSecond >= 60 && diffSecond < 3600) {
      const minutes = Math.trunc(diffSecond / 60);
      const seconds = diffSecond % 60;
      activity = `${minutes}m ${seconds}s`;
    } else if (diffSecond >= 3600 && diffSecond < 86400) {
      const minutes = Math.trunc((diffSecond % 3600) / 60);
      const hours = Math.trunc(diffSecond / 3600);
      activity = `${hours}h ${minutes}m`;
    } else if (diffSecond >= 86400) {
      const hours = Math.trunc((diffSecond % 86400) / 3600);
      const days = Math.trunc(diffSecond / 86400);
      activity = `${days}d ${hours}h`;
    }

    return activity;
  }
}
